/** All zmanim are shown in Israel time. */
export const TIME_ZONE = "Asia/Jerusalem";

export const MS_PER_SECOND = 1000;
export const MS_PER_MINUTE = 60 * MS_PER_SECOND;

/** A calendar date with no time or zone. `month` is 1-12. */
export interface PlainDate {
  year: number;
  month: number;
  day: number;
}

export interface GeoPoint {
  latitude: number;
  longitude: number;
  /** Meters above sea level. Used only by elevation-adjusted sunrise/sunset. */
  elevation: number;
}

export function addDays(date: PlainDate, days: number): PlainDate {
  const d = new Date(Date.UTC(date.year, date.month - 1, date.day + days));
  return { year: d.getUTCFullYear(), month: d.getUTCMonth() + 1, day: d.getUTCDate() };
}

export function parsePlainDate(iso: string): PlainDate {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (!match) throw new Error(`Invalid date: ${iso}`);
  const date = { year: Number(match[1]), month: Number(match[2]), day: Number(match[3]) };
  const roundTrip = addDays(date, 0);
  if (roundTrip.month !== date.month || roundTrip.day !== date.day) {
    throw new Error(`Invalid date: ${iso}`);
  }
  return date;
}

export function formatPlainDate(date: PlainDate): string {
  const pad = (n: number, len = 2) => String(n).padStart(len, "0");
  return `${pad(date.year, 4)}-${pad(date.month)}-${pad(date.day)}`;
}
